var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "header",
      staticClass: "vs-table__header",
      style: { top: _vm.headerTop + "px" }
    },
    [
      _c(
        "div",
        { staticClass: "vs-table__header-row" },
        _vm._l(_vm.headings, function(heading) {
          return _c("vs-table-heading", {
            key: heading,
            attrs: {
              heading: heading,
              processing: _vm.processing,
              "sort-column": _vm.sortColumn,
              "sort-direction": _vm.sortDirection
            },
            on: {
              "header-action": function($event) {
                return _vm.$emit("header-action", $event)
              },
              sort: function($event) {
                return _vm.$emit("sort", $event)
              },
              help: function($event) {
                return _vm.$emit("help", $event)
              }
            }
          })
        }),
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }